'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dUser from "./mealorama.-User.js";
var $p;
/** @constructor */
function $c_Lmealorama_User$() {
}
export { $c_Lmealorama_User$ as $c_Lmealorama_User$ };
$p = $c_Lmealorama_User$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_User$;
/** @constructor */
function $h_Lmealorama_User$() {
}
export { $h_Lmealorama_User$ as $h_Lmealorama_User$ };
$h_Lmealorama_User$.prototype = $p;
$p.m = (function() {
  return "User";
});
$p.aSC = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dUser.$c_Lmealorama_User($x_1.l, $x_1.h, x$0.g(1), x$0.g(2), x$0.g(3), x$0.g(4), (!(!x$0.g(5))), x$0.g(6), x$0.g(7), x$0.g(8), (!(!x$0.g(9))), x$0.g(10), x$0.g(11), (!(!x$0.g(12))), x$0.g(13));
});
var $d_Lmealorama_User$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_User$, "mealorama.User$", ({
  Ha: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_User$ as $d_Lmealorama_User$ };
var $n_Lmealorama_User$;
function $m_Lmealorama_User$() {
  if ((!$n_Lmealorama_User$)) {
    $n_Lmealorama_User$ = new $c_Lmealorama_User$();
  }
  return $n_Lmealorama_User$;
}
export { $m_Lmealorama_User$ as $m_Lmealorama_User$ };
//# sourceMappingURL=mealorama.-User$.js.map
